import React from 'react';
import ThankYouPage from 'components/AuthNew/ThankYouPage';
import styles from './style.module.css';
const RequestSuccess = () => {
  return (
    <ThankYouPage
      message={
        <p className={styles.paragraph}>
          Please check your <strong className={styles.bold}>email</strong>. We sent you <br /> instructions to
          reset your password.
        </p>
      }
      // header="Forgot Password"
      linkTo="/"
      linkText="Back to Login"
    />
  );
};

RequestSuccess.propTypes = {};

RequestSuccess.defaultProps = {};

export default RequestSuccess;
